import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  profileCardContainer: {
    '&:not(.generalCard)': {
      margin: theme.spacing(4, 0)
    }
  }
}));
